import { create } from 'zustand';

interface PartnrBetaState {
  isPartnrBetaEnabled: boolean;
  setPartnrBetaEnabled: (enabled: boolean) => void;
}

const STORAGE_KEY = 'partnr-beta-enabled';

export const usePartnrBetaStore = create<PartnrBetaState>((set) => ({
  isPartnrBetaEnabled: localStorage.getItem(STORAGE_KEY) !== 'false', // Default true
  setPartnrBetaEnabled: (enabled) => {
    localStorage.setItem(STORAGE_KEY, String(enabled));
    set({ isPartnrBetaEnabled: enabled });
  },
}));
